function setCookie(c_name, value, exdays) {
	var now = new Date();
	var time = now.getTime();
	time += 3600 * 1000 * 24 * exdays;
	now.setTime(time);
	var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + now.toUTCString());
	document.cookie = c_name + "=" + c_value + "; path=/";
}

function getCookie(c_name) {
	var i, x, y, ARRcookies = document.cookie.split(";");
	for (i = 0; i < ARRcookies.length; i++) {
		x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
		y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
		x = x.replace(/^\s+|\s+$/g, "");
		if (x == c_name) {
			return unescape(y);
		}
	}
}

window.setCookie = setCookie;
window.getCookie = getCookie;
